const UNICODE_SPACE_PATTERN = /[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g
const INSTALLED = Symbol.for('scouts.localeNumberSpaceFix')

function replaceUnicodeSpaces(value: string): string
{
    return value.replace(UNICODE_SPACE_PATTERN, ' ')
}

function installLocaleNumberSpaceFix(): void
{
    const current = Number.prototype.toLocaleString as typeof Number.prototype.toLocaleString & {
        [INSTALLED]?: boolean
    }

    if (current[INSTALLED]) {
        return
    }

    const original = Number.prototype.toLocaleString
    const patched = function (
        this: number,
        locales?: string | string[],
        options?: Intl.NumberFormatOptions,
    ): string {
        return replaceUnicodeSpaces(original.call(this, locales, options))
    } as typeof current

    patched[INSTALLED] = true
    Number.prototype.toLocaleString = patched
}

export {
    replaceUnicodeSpaces,
    installLocaleNumberSpaceFix,
}
